import { render, staticRenderFns } from "./AddTaxRate.vue?vue&type=template&id=601bd7e4&"
import script from "./AddTaxRate.vue?vue&type=script&lang=js&"
export * from "./AddTaxRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports